import { ensureRecaptcha } from './loader';

const SITE_KEY = import.meta.env.VUE_APP_RECAPTCHA_KEY;

export function initRecaptcha() {
  if (SITE_KEY) void ensureRecaptcha(SITE_KEY);
}

export async function getRecaptchaToken(action: string) {
  if (!SITE_KEY) throw new Error('reCAPTCHA siteKey is not set');

  const grecaptcha = await ensureRecaptcha(SITE_KEY);
  return grecaptcha.execute(SITE_KEY, { action });
}
